export default __webpack_public_path__ + "static/PancakeSwap-a20c9ef1f3bebda15ed803abaa149e32.svg";